import {
  RawFamilySearchPersonResults,
  useFamilySearch,
} from '@ltvco/refresh-lib/fmt';
import {
  AdvancedSearchURLParams,
  getAncestorSearchParams,
} from '@ltvco/refresh-lib/v2';
import React, { useEffect, useState } from 'react';

interface FamilySearchFetcherProps {
  searchData: AdvancedSearchURLParams;
  setFamilySearchResults: (
    // eslint-disable-next-line no-unused-vars
    results: RawFamilySearchPersonResults | undefined
  ) => void;
}

export function FamilySearchFetcher({
  searchData,
  setFamilySearchResults,
}: FamilySearchFetcherProps) {
  const [ip, setIp] = useState<string>('');

  useEffect(() => {
    (async () => {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();

      setIp(data.ip);
    })();
  }, []);

  const { data, isLoading, isError } = useFamilySearch(
    ip,
    getAncestorSearchParams(searchData),
    !!ip
  );

  const result = data as RawFamilySearchPersonResults | undefined;

  useEffect(() => {
    if (!isLoading && !isError) {
      setFamilySearchResults(result);
    } else {
      setFamilySearchResults(undefined);
    }
  }, [isLoading, isError, result, setFamilySearchResults]);

  return <React.Fragment />;
}
